export default "__VITE_ASSET__oO2IUqVi__"